// extracted by mini-css-extract-plugin
module.exports = {"genres":"Genres_genres__ChGQ6","genre":"Genres_genre__7WKw3"};